import * as React from 'react';
import {
  AI_ALERTS_SENSITIVITY_CONTROL_TITLE,
  AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS,
  SeverityColors,
} from '@src/utils/aiAlerts/mapping';
import { Col, Divider, Row } from 'antd';
import { StyledSelect } from './styled';
import { PRODUCT_MODE_MAP } from '@src/utils/constants';

const Header = ({ selectedProduct, onProductChange }) => {
  const style: React.CSSProperties = { padding: '8px 0', fontWeight: 500, fontSize: 14 };
  const titleColSpan = selectedProduct === PRODUCT_MODE_MAP.AI ? 12 : 9;
  const colSpan = selectedProduct === PRODUCT_MODE_MAP.AI ? 12 : 5;

  return (
    <>
      <StyledSelect
        defaultValue={selectedProduct}
        size="large"
        dropdownStyle={{ minWidth: '100px', padding: '10px 5px' }}
        options={AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS}
        onChange={onProductChange}
      />
      <Divider type="vertical" style={{ borderColor: 'rgba(0, 0, 0, 0.8)' }} />
      <span style={{ fontWeight: 'normal', fontSize: 18 }}>
        {AI_ALERTS_SENSITIVITY_CONTROL_TITLE}
      </span>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        style={{ padding: '20px 0 0 0', marginRight: '-30px' }}
      >
        <Col className="gutter-row" span={titleColSpan}>
          <div style={style}>Metrics</div>
        </Col>
        <Col className="gutter-row" span={colSpan}>
          <div style={{ ...style, color: SeverityColors.Info }}>Info</div>
        </Col>
        {selectedProduct !== PRODUCT_MODE_MAP.AI ? (
          <>
            <Col className="gutter-row" span={colSpan}>
              <div style={{ ...style, color: SeverityColors.Warning }}>Warning</div>
            </Col>
            <Col className="gutter-row" span={colSpan}>
              <div style={{ ...style, color: SeverityColors.Critical }}>Critical</div>
            </Col>
          </>
        ) : null}
      </Row>
    </>
  );
};

export default Header;
